let currentCustomization = null;
let customizationWrapper, customizationDropdown, saveCustomizationCheckbox;
let flexFields;
let customizations;

function init() {
  customizations = window.jpSavedCustomizations?.customizations ?? [];
  if (!customizations.length) { return; }
  
  customizationWrapper = document.querySelector('.jp-saved-customizations-block');
  if (!customizationWrapper) { return; }

  customizationDropdown = customizationWrapper.querySelector('.jp-saved-customizations__select');
  if (!customizationDropdown) { return; }

  saveCustomizationCheckbox = customizationWrapper.querySelector('input[name=jp_save_customization]');
  if (!saveCustomizationCheckbox) { return; }
  
  flexFields = Array.from(document.querySelectorAll('.fpf-input-field'));

  const resetCustomizationOnChange = (event) => {
    if (!currentCustomization) { return; }
    
    const target = event.target;
    const fieldId = target.name;
    const matchesCustomization = (currentCustomization.get(fieldId) === target.value);
    
    // No change - early return.
    if (matchesCustomization) { return; }

    clearCurrentCustomization();
  };

  flexFields.forEach(el => {
    el.addEventListener('change', resetCustomizationOnChange);
    el.addEventListener('input', resetCustomizationOnChange);
  });

  customizationDropdown.addEventListener('change', () => {
    const customizationId = customizationDropdown.value;

    if (!customizationId) {
      clearCurrentCustomization();
      return;
    }

    const customization = customizations.find(item => item.id === customizationId);

    if (!customization) {
      // Should not happen.
      console.error(`Could not find customization ${ customizationId } (${ customizationDropdown.options[customizationDropdown.selectedIndex].text })`);
      return; 
    }
    
    setCurrentCustomization(customization);
  });
}

function applyCustomization(customizationFieldMap) {
  customizationFieldMap.forEach((value, id) => {
    const fieldEl = document.getElementById(id);
    
    if (!fieldEl) { return; }
    fieldEl.value = value;
    triggerChange(fieldEl);
  });
}

function triggerChange(element) {
  element.dispatchEvent(new Event('change', { bubbles: true }));
}

/** @return Map<fieldId, fieldValue) */
function fieldMapFromCustomization(customization) {
  const map = new Map();
  customization.fields.forEach((field) => { map.set(String(field.id), field.value) });
  return map;
}

function setCurrentCustomization(customization) {
  currentCustomization = fieldMapFromCustomization(customization);
  customizationWrapper.classList.add('jp-saved-customizations-block--locked');
  saveCustomizationCheckbox.disabled = true;
  saveCustomizationCheckbox.checked = false;

  applyCustomization(currentCustomization);
}

function clearCurrentCustomization() {
  if (currentCustomization == null) { return; }
  
  currentCustomization = null;
  customizationWrapper.classList.remove('jp-saved-customizations-block--locked');
  customizationDropdown.value = '';
  saveCustomizationCheckbox.disabled = false;
  saveCustomizationCheckbox.checked = false;
}

export default { init };
